import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';
import { NekoSpinner } from '../misc/Spinner';
import { useClasses } from '../hooks';

import { Icon } from '@iconify/react';
import checkboxBlankOutline from '@iconify/icons-mdi/checkbox-blank-outline';
import checkboxMarked from '@iconify/icons-mdi/checkbox-marked';
/**
 * @param {string} id
 * @param {string} name
 * @param   {bool} checked
 * @param {string} label
 * @param {string} description
 */
const StyledNekoCheckbox = Styled(props => {
  const { name, checked = false, onChange, label, description, isPro, disabled,
    requirePro = false, isBusy = false, small = false } = props;

  const showUpProOnly = requirePro && !isPro;
  const isDisabled = disabled || showUpProOnly;
  const classNames = useClasses('neko-checkbox', props.className, { disabled: isDisabled }, { small });
  const checkboxClassNames = useClasses('neko-checkbox', { disabled: isDisabled }, { small });

  const onClick = (e) => {
    if (isDisabled) {
      return;
    }
    if (!onChange) {
      console.log(`The onChange handler it not set for the NekoCheckbox.`, props);
      return;
    }
    onChange(!checked, name, e);
  };

  return (
    <div className={classNames}
      onClick={(e) => e.stopPropagation() }>
      {/* <input id={id} name={name} type="checkbox" defaultChecked={false} disabled={isDisabled || isBusy} /> */}
      <div className="neko-content" onClick={onClick}>
        <div className="neko-checkbox-check-container">

          {isBusy && <div className='neko-checkbox-busy-container'>
            <div className={checkboxClassNames}>
              <NekoSpinner type="circle" size="16px" />
            </div>
            {/* <Icon icon={checkboxBlankOutline} width="30px" height="30px" color="var(--neko-control-primary)" />
              <NekoSpinner type="circle" size="16px" style={{ position: 'absolute', top: '7px', left: '7px' }} /> */}
            </div>
          }

          {!isBusy && <>
            {/* <div style={{ width: 30, height: 30, border: '1.5px solid #d2e4f3' }} /> */}
            <div className={checkboxClassNames}>
              <div className={`neko-checked-mark${checked ? ' neko-checked' : ''}`} />
            </div>
            {/* <Icon icon={checked ? checkboxMarked : checkboxBlankOutline} width="30px" height="30px" 
              color={isDisabled ? 'var(--neko-disabled-form)' : 'var(--neko-control-primary)'} /> */}
          </>}

        </div>
        {(label || showUpProOnly || description) &&
          <div className="neko-checkbox-inner-container">
            <span className="neko-label-container">
              <span className="neko-label">{label}</span>
              <ProOnly className="inline" show={showUpProOnly} style={{ position: 'relative', top: -1 }} />
            </span>
            {description ? <small className="description">{description}</small> : null}
          </div>
        }
      </div>
    </div>
  );
})`
  font-family: ${Theme.fontFamily};
  user-select: none;
  transition: color 0.3s ease;

  &.disabled {
    color: var(--neko-disabled-form);
    
    .neko-content {
      cursor: default;
    }

    .neko-checkbox-check-container, .neko-label, .description {
      opacity: 0.35;
    }
  }

  input {
    display: none;
  }

  .neko-content {
    cursor: pointer;
    display: flex;
  }

  .neko-checkbox-check-container {
    display: flex;
    align-content: center;
    flex-basis: 30px;

    .neko-checkbox-busy-container {
      position: relative
    }
  }

  &.small {
    .neko-checkbox-check-container {
      flex-basis: 23px;
    }
  }

  .neko-checkbox-inner-container {
    margin-left: 4px;

    .neko-label-container {
      display: flex;
      margin-top: 5px;

      .neko-label {
        display: block;
        font-size: ${Theme.fontSizeText};
        
      }
    }

    .neko-content {
      display: block;
      font-size: 14px;
      line-height: 28px;
    }
    
    .description {
      display: block;
      font-size: ${Theme.fontSizeSmall};
      margin-top: 2px;
      line-height: 14px;
      color: var(--neko-dark-gray);

      * {
        font-size: ${Theme.fontSizeSmall};
        line-height: inherit;
        margin: 0;
      }
    }
  }

  .neko-checkbox {
    width: 27px;
    height: 27px;
    border-radius: 4px;
    background-color: var(--neko-input-background);
    border: 1.5px solid var(--neko-input-border);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.small {
      width: 20px;
      height: 20px;
    }

    .neko-checked-mark {
      opacity: 0;
      background-color: var(--neko-control-primary);
      background-image: var(--neko-control-gradient);
      width: 78%;
      height: 78%;
      border-radius: 4px;
      transition: opacity 0.2s ease-in-out;

      &.neko-checked {
        opacity: 1;
      }
    }

    &.disabled {
      border: 1.5px solid var(--neko-disabled-form);
      cursor: not-allowed;
    }
  }
`;

const NekoCheckbox = (props) => {
  return (<StyledNekoCheckbox {...props} />);
};

NekoCheckbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  isPro: PropTypes.bool,
  requirePro: PropTypes.bool,
  isBusy: PropTypes.bool,
  small: PropTypes.bool,
};

NekoCheckbox.defaultProps = {
  name: undefined,
  checked: false,
  label: undefined,
  description: undefined,
  isPro: false,
  requirePro: false,
  isBusy: false,
  small: false,
};

export { NekoCheckbox };
